import { Builder } from '@builder.io/react';

import UnbounceZipCodeField from './unbounce-zipcode-field';

Builder.registerComponent(UnbounceZipCodeField, {
  name: 'UnbounceZipCodeField',
  friendlyName: 'Unbounce Zipcode Field',
  inputs: [
    {
      name: 'title',
      type: 'string',
      required: true,
      defaultValue: 'Looking for Health Insurance?',
    },
    {
      name: 'subtitle',
      type: 'richText',
      required: true,
      defaultValue: "Find affordable healthcare that's right for you",
    },
    {
      name: 'buttonCta',
      type: 'string',
      required: true,
      defaultValue: 'See Options',
    },
    {
      name: 'popUnderUrl',
      type: 'string',
      required: true,
      defaultValue:
        'https://www.healthcare.com/healthcare-insurance/survey/?zip={{zipCode}}',
      description:
        'The URL to open in a pop-under when the user clicks the button. Use {{zipCode}} to insert the entered zip code.',
    },
    {
      name: 'popOutUrl',
      type: 'string',
      required: false,
      description:
        'The URL to open in a new tab when the user clicks the button. Use {{zipCode}} to insert the entered zip code.',
    },
    {
      name: 'alwaysStack',
      type: 'boolean',
      required: false,
      defaultValue: false,
      description:
        'If true, the input and button will always be stacked vertically, even on larger screens.',
    },
  ],
});
